module.exports = __webpack_public_path__ + "static/media/cabinet_milestone_logo.0ff0053d.svg";